import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { PaymentCredit } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
@Component({
    selector: 'app-payment-credits',
    templateUrl: './payment-credits.component.html',
    styleUrls: ['./payment-credits.component.scss'],
    standalone: false
})
export class PaymentCreditsComponent implements OnInit {
    paymentCredits: PaymentCredit[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;
    onOptionChanged = SharedModule.onOptionChanged;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.paymentCredits = await this.uow.getPaymentCredits() as PaymentCredit[];
        console.log(this.paymentCredits);
        this.appInfo.pleaseWaitHide();
    }

    async createCredit() {
        this.router.navigate(['/sales-orders/new'], { queryParams: { credit: true } });
    }

    async rowPrepare(e) {
        if (e.rowType !== 'data') return;
        if (e.data.availableAmount === 0) {
            e.rowElement.className = e.rowElement.className + ' payment-transaction-complete';
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

}
